export default __webpack_public_path__ + "static/media/img-quatro-palhacos.813d88fe.png";